import { Toast } from "vant";
// 判断当前接口返回是否正常
const checkOk = data => {
  if (data.status == 200 && data.data.code == 0) {
    return true;
  } else {
    return false;
  }
};

// 处理当前异常接口问题
const showToast = data => {
  switch (data.status) {
    case 404:
      // console.log("接口不存在");
      Toast.fail("url未找到！");
      break;
    case 500:
      // console.log("服务器异常");
      Toast.fail("服务器异常");
      break;
    case 200:
      Toast.fail(data.data.message);
      // 提示错误信息
      break;
    default:
      // console.log("服务器异常");
      Toast.fail("服务器异常");
      break;
  }
};

// 过滤请求参数
const filterData = data => {
  let obj = {};
  Object.keys(data).forEach(val => {
    if (data[val] !== "" && data[val] !== null && data[val] !== undefined) {
      obj[val] = data[val];
    }
  });
  return obj;
};

export { checkOk, showToast, filterData };
